import { Add as AddIcon } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import React from 'react';

import StructureForm from '../../Structures/Create';

const AddPropertyButton = (): JSX.Element => {
  const [isAddStructureFormOpen, setIsAddStructureFormOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          padding: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: 2,
          boxShadow: 3,
          position: 'relative',
          width: 250,
          height: '200px',
          borderStyle: 'dashed',
          borderWidth: 2,
          borderColor: 'primary.main',
          color: 'primary.main',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'primary.light',
            borderColor: 'primary.dark',
          },
        }}
        onClick={() => setIsAddStructureFormOpen(true)}
      >
        <div>
          <AddIcon sx={{ width: 60, height: 60, marginBottom: 1 }} />
          <Typography variant="h6">Add New Property</Typography>
        </div>
      </Button>
      <StructureForm
        open={isAddStructureFormOpen}
        onClose={() => setIsAddStructureFormOpen(false)}
      />
    </>
  );
};

export default AddPropertyButton;
